module.exports = __webpack_public_path__ + "img/schedule.e0109813.svg";